const ACTIONS = ['list', 'read', 'create', 'edit', 'delete'];

export const hasPermission = (user, perm) => {
  if (user?.Codigo === 1) return true;
  const p = user?.permissions;
  return Array.isArray(p) && p.includes(perm);
};

export const hasAnyPermission = (user, perms) => {
  if (user?.Codigo === 1) return true;
  const p = user?.permissions;
  if (!Array.isArray(p) || !Array.isArray(perms) || perms.length === 0) return false;
  return perms.some((x) => p.includes(x));
};

// si puede listar o leer, lo dejamos entrar/ver menu
export const canViewModule = (user, moduleKey) => {
  return hasAnyPermission(user, [`${moduleKey}:list`, `${moduleKey}:read`]);
};

// si tiene cualquiera de estas puede editar
export const canEditModule = (user, moduleKey) => {
  return hasAnyPermission(user, [
    `${moduleKey}:create`,
    `${moduleKey}:edit`,
    `${moduleKey}:delete`,
  ]);
};

export const canEditExplicit = (user, moduleKey) => hasPermission(user, `${moduleKey}:edit`);

// permiso de creación del módulo
export const canCreateModule = (user, moduleKey) => hasPermission(user, `${moduleKey}:create`);
